<template>
  <div>
    <breadcrumbs home="Taxes" :back="back"/>

    <purtrak-table name="taxes" objectType="taxes" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="taxes2"
                   fields="id,name,active,purchaseRate,salesRate,ref,systemDefined"
                   :listFilters="listFilters"
                   :item-class="tax => (!tax.active ? 'grey--text ' : '')"
                   @dblclick="tax => tax.ref || tax.systemDefined ? '' : $router.push({name:'SettingsTaxesEdit',params:{taxId:tax.id}})"
                   title="Taxes"
                   :print-info="{pageSize:'portrait', subTitle:[]}"
                   download-endpoint="taxesExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.search='';filters.status='1'">
          <v-list-item>
            <filter-search label="Tax name" v-model="filters.search"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{value:'1',text:'Active'},{value:'0',text:'Inactive'}]" v-model="filters.status"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.search" close small class="ml-1" @click:close="filters.search=''">Tax: {{filters.search}}</v-chip>
          <v-chip v-show="filters.status!='1'" close small class="ml-1" @click:close="filters.status='1'">{{filters.status=='0'?'Inactive':'All'}}</v-chip>
        </template>
      </template>
      <template v-slot:menu v-if="!readOnly">
        <v-list-item :to="{name:'SettingsTaxesEdit'}"><v-list-item-title>Create tax</v-list-item-title></v-list-item>
        <template v-if="$store.getters.company.connectedToAccounting">
          <v-divider/>
          <v-list-item @click="sync()"><v-list-item-title>Sync taxes with QBO</v-list-item-title></v-list-item>
        </template>
      </template>

      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'SettingsTaxesEdit'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}" v-if="!readOnly">
        <v-btn v-if="!item.systemDefined && !item.ref" small icon @click.stop="tax = item;showDelete = true"><v-icon small >mdi-delete</v-icon></v-btn>
      </template>
      <template v-slot:item.name="{item,value,printing}">
        <template v-if="printing || item.systemDefined || item.ref">{{value}}</template>
        <template v-else>
          <v-hover v-if="!readOnly" v-slot="{hover}">
            <a @click.stop="$router.push({name:'SettingsTaxesEdit',params:{taxId:item.id}})"
                :class="{'text-decoration-underline':hover,'grey--text':!item.active}">{{item.name}}</a>
          </v-hover>
          <div v-else :class="{'grey--text':!item.active}">{{item.name}}</div>
          <div v-if="!item.active" class="grey--text text-caption">Inactive</div>
        </template>
      </template>
      <template v-slot:item.purchaseRate="{value}">
        {{value | number(1)}}{{value ? '%' : ''}}
      </template>
      <template v-slot:item.salesRate="{value}">
        {{value | number(1)}}{{value ? '%' : ''}}
      </template>
      <template v-slot:item.ref="{value,printing}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon v-else-if="value">mdi-check</v-icon>
      </template>
      <template v-slot:item.systemDefined="{value,printing}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon v-else-if="value">mdi-check</v-icon>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="tax.name" @delete="performDeleteTax"/>
  </div>
</template>

<script>

export default {
  name: 'SettingTaxes',
  props: {
    back: {type:Array, required:false}
  },
  data() {
    return {
      filters: {
        search: '',
        status: '1'
      },
      tax: {},
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true},
                       { value: 'salesRate', visible:true},
                       { value: 'purchaseRate', visible:true},
                       { value: 'ref', visible:true},
                       { value: 'systemDefined', visible:true}
                       ],
      headers: [{ text: 'TAX', value: 'name', width:'30%',sortable:true},
                { text: 'SALES RATE', value: 'salesRate', width:'15%', align:'right',sortable:false},
                { text: 'PURCHASE RATE', value: 'purchaseRate', width:'15%', align:'right', sortable:false},
                { text: 'QBO DEFINED', value: 'ref', width:'15%', align:'center', sortable:false},
                { text: 'SYS DEFINED', value: 'systemDefined', width:'15%', align:'center', sortable:false},
                { text: '' , value:'action', width:'5%', sortable:false,align:'center'}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('config.write');
    },
    listFilters() {
      const filters = [];
      if (this.filters.search)
        filters.push({field:'name', comparator:'contains', value:this.filters.search});
      if (this.filters.status != '2')
        filters.push({field:'active', comparator:'eq', value:this.filters.status === '1' ? 'true' : 'false'});
      return filters;
    }
  },
  methods: {
    async performDeleteTax() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingTaxes($id:ID!) {
                                                objectDelete(id:$id)
                                              }`,
                                          {id:this.tax.id});
      this.loading = false;
      if (!results.error) {
        this.$store.commit('setError', {type:'success',message:`Deleted tax`});
        this.$refs.table?.buildList();
      }
    },
    async sync() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingTaxes {
                                             accountingIntegrationSync(step:"taxes") {name}
                                           }`, {});
      if (!results.error) {
        this.$store.commit('setError', {type:'success',message:`Synced taxes with QBO`});
        this.$refs.table?.buildList();
      }
    }
  }
}
</script>